/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum LumenProductId {
    LocalInbound = 2036,
    EnhancedLocalService = 2042,
}